import { getCurrencyFromCountryCode } from 'Components/Shopify/Utils/currencyUtils';
import { getLanguageAndCurrencyConfig } from 'Components/Shopify/Utils/utils';
import useUser from '_services/Redux/User/Selector/useUser';

/**
 * Currency for subscription pricing, normalized to the currencies we support.
 * Derived from the user's country. Falls back to USD if unsupported.
 */
export const useSubscriptionCurrency = (): 'USD' | 'EUR' | 'NOK' | 'GBP' => {
    const { user } = useUser();
    const { countryCode } = getLanguageAndCurrencyConfig(user);
    const currency = getCurrencyFromCountryCode(countryCode);

    return (['USD', 'EUR', 'NOK', 'GBP'] as const).includes(currency as never)
        ? (currency as 'USD' | 'EUR' | 'NOK' | 'GBP')
        : 'USD';
};

export default useSubscriptionCurrency;
